export default __webpack_public_path__ + "static/media/activity-group-red.589b4919.svg";